export enum WorkerWindowMsgType {
  TYPE_WORKER_WINDOW_INIT_INFO = 'TYPE_WORKER_WINDOW_INIT_INFO', // 给工作窗口发生初始化信息
  TYPE_WORKER_WINDOW_READY = 'TYPE_WORKER_WINDOW_READY', // 工作窗口准备完成通知
  TYPE_SET_PARENT_ID = 'TYPE_SET_PARENT_ID', // 设置父窗口ID
  TYPE_UNRESPONSIVE = 'UNRESPONSIVE', // 无响应通知
  TYPE_ABEND = 'TYPE_ABEND', // 工作进程异常结束

  TYPE_CO_SYNC_MESSAGE = 'TYPE_CO_SYNC_MESSAGE', // 同步盘消息
}

export enum WorkerWindowRunAction {
  TYPE_SYNC = 'TYPE_SYNC', // 同步盘
}

/**
 * @description 创建后台进程时传参的基础类型
 * @export
 * @interface CreateWorkerProcessBaseData
 */
export interface CreateWorkerProcessBaseData {
  parentWebContentsId?: number;
  workerWebContentsId?: number;
  workerName?: string;
}

// TODO: 此处暂时为了解耦，不引入下面地址里的 CoSyncInfo，因此先定义类型为 any。
// import { CoSyncInfo } from '@/workerProcessRenderer/scripts/CoSyncEngine/common/CoSyncConfig';，
type CoSyncInfo = any;
/**
 * @description 创建同步盘工作进程所需数据
 * @export
 * @interface CreateSyncWokerProcessData
 * @extends {CreateWorkerProcessBaseData}
 */
export interface CreateSyncWokerProcessData extends CreateWorkerProcessBaseData {
  userInfo: CoFile.UserInfo;
  config: CoSyncInfo;
  language: string;
}

export interface WorkerWindowMsgBaseInfo {
  type: WorkerWindowMsgType;
  parentWebContentsId: number;
  workerWebContentsId: number;
  workerName?: string;
}

export interface WorkerWindowReadyInfo extends WorkerWindowMsgBaseInfo {
  type: WorkerWindowMsgType.TYPE_WORKER_WINDOW_READY;
}

export interface WorkerWindowAbendInfo extends WorkerWindowMsgBaseInfo {
  type: WorkerWindowMsgType.TYPE_ABEND;
  reason: string;
}

export type WorkerWindowMsgInfo = WorkerWindowReadyInfo | WorkerWindowAbendInfo;
